export default "__VITE_ASSET__383c70a4__"